import { t as e } from "./utils-DiFe-_ei.js";
import { i as t, n, r, t as i } from "./dist-By11B3Nf.js";
import { a, r as o } from "./dist-7tgynhKG.js";
import { i as s, l as c, o as l } from "./es2015-Dfq2CQHn.js";
import { t as u } from "./dist-B3lndwlS.js";
import { t as d } from "./dist-CUIQpIad.js";
import { i as f, n as p, r as m, t as h } from "./dist-8NAz9rgL.js";
import { a as g, i as _, n as v, r as y } from "./dist-Bbyy0Cx5.js";
import { t as b } from "./dist-Bl9r4eY0.js";
import * as x from "react";
import { useEffect as S, useState as C } from "react";
import { jsx as w, jsxs as T } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-tooltip@1.2.13_@types+react-dom@19.2.3_@types+react@19.2.17__@types+rea_8b76f7f876f59d5a21b75dce58a7a14e/node_modules/@radix-ui/react-tooltip/dist/index.mjs
var E = Object.defineProperty, D = (e, t) => E(e, "name", {
	value: t,
	configurable: !0
}), [O, k] = t("Tooltip", [f]), A = f(), j = "TooltipProvider", M = 700, N = "tooltip.open", [ee, P] = O(j), te = /* @__PURE__ */ D((e) => {
	let { __scopeTooltip: t, delayDuration: n = M, skipDelayDuration: r = 300, disableHoverableContent: i = !1, children: a } = e, o = x.useRef(!0), s = x.useRef(!1), c = x.useRef(0);
	return x.useEffect(() => {
		let e = c.current;
		return () => window.clearTimeout(e);
	}, []), /* @__PURE__ */ w(ee, {
		scope: t,
		isOpenDelayedRef: o,
		delayDuration: n,
		onOpen: x.useCallback(() => {
			r <= 0 || (window.clearTimeout(c.current), o.current = !1);
		}, [r]),
		onClose: x.useCallback(() => {
			r <= 0 || (window.clearTimeout(c.current), c.current = window.setTimeout(() => o.current = !0, r));
		}, [r]),
		isPointerInTransitRef: s,
		onPointerInTransitChange: x.useCallback((e) => {
			s.current = e;
		}, []),
		disableHoverableContent: i,
		children: a
	});
}, "TooltipProvider"), F = "Tooltip", [ne, I] = O(F), re = /* @__PURE__ */ D((e) => {
	let { __scopeTooltip: t, children: n, open: r, defaultOpen: a, onOpenChange: o, disableHoverableContent: s, delayDuration: l } = e, u = P(F, e.__scopeTooltip), d = A(t), [f, p] = x.useState(null), [h, g] = x.useState(void 0), _ = c(), v = x.useRef(0), y = s ?? u.disableHoverableContent, b = l ?? u.delayDuration, S = x.useRef(!1), [C, T] = i({
		prop: r,
		defaultProp: a ?? !1,
		onChange: /* @__PURE__ */ D((e) => {
			e ? (u.onOpen(), document.dispatchEvent(new CustomEvent(N))) : u.onClose(), o?.(e);
		}, "onChange"),
		caller: F
	}), E = x.useMemo(() => C ? S.current ? "delayed-open" : "instant-open" : "closed", [C]), O = x.useCallback(() => {
		window.clearTimeout(v.current), v.current = 0, S.current = !1, T(!0);
	}, [T]), k = x.useCallback(() => {
		window.clearTimeout(v.current), v.current = 0, T(!1);
	}, [T]), j = x.useCallback(() => {
		window.clearTimeout(v.current), v.current = window.setTimeout(() => {
			S.current = !0, T(!0), v.current = 0;
		}, b);
	}, [b, T]);
	x.useEffect(() => () => {
		v.current &&= (window.clearTimeout(v.current), 0);
	}, []);
	let M = h ?? _;
	return /* @__PURE__ */ w(m, {
		...d,
		children: /* @__PURE__ */ w(ne, {
			scope: t,
			contentId: M,
			setContentId: g,
			open: C,
			stateAttribute: E,
			trigger: f,
			onTriggerChange: p,
			onTriggerEnter: x.useCallback(() => {
				u.isOpenDelayedRef.current ? j() : O();
			}, [
				u.isOpenDelayedRef,
				j,
				O
			]),
			onTriggerLeave: x.useCallback(() => {
				y ? k() : (window.clearTimeout(v.current), v.current = 0);
			}, [k, y]),
			onOpen: O,
			onClose: k,
			disableHoverableContent: y,
			children: n
		})
	});
}, "Tooltip"), L = "TooltipTrigger", ie = /* @__PURE__ */ x.forwardRef(/* @__PURE__ */ D(function(e, t) {
	let { __scopeTooltip: n, ...i } = e, o = I(L, n), s = P(L, n), c = A(n), l = a(t, x.useRef(null), o.onTriggerChange), d = x.useRef(!1), f = x.useRef(!1), p = x.useCallback(() => d.current = !1, []);
	return x.useEffect(() => () => document.removeEventListener("pointerup", p), [p]), /* @__PURE__ */ w(h, {
		asChild: !0,
		...c,
		children: /* @__PURE__ */ w(u.button, {
			"aria-describedby": o.open ? o.contentId : void 0,
			"data-state": o.stateAttribute,
			...i,
			ref: l,
			onPointerMove: r(e.onPointerMove, (e) => {
				e.pointerType !== "touch" && !f.current && !s.isPointerInTransitRef.current && (o.onTriggerEnter(), f.current = !0);
			}),
			onPointerLeave: r(e.onPointerLeave, () => {
				o.onTriggerLeave(), f.current = !1;
			}),
			onPointerDown: r(e.onPointerDown, () => {
				o.open && o.onClose(), d.current = !0, document.addEventListener("pointerup", p, { once: !0 });
			}),
			onFocus: r(e.onFocus, () => {
				d.current || o.onOpen();
			}),
			onBlur: r(e.onBlur, o.onClose),
			onClick: r(e.onClick, o.onClose)
		})
	});
}, "TooltipTrigger")), R = "TooltipPortal", [ae, oe] = O(R, { forceMount: void 0 }), se = /* @__PURE__ */ D((e) => {
	let { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, a = I(R, t);
	return /* @__PURE__ */ w(ae, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ w(d, {
			present: n || a.open,
			children: /* @__PURE__ */ w(s, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "TooltipPortal"), z = "TooltipContent", ce = /* @__PURE__ */ x.forwardRef(/* @__PURE__ */ D(function(e, t) {
	let n = oe(z, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, o = I(z, e.__scopeTooltip);
	return /* @__PURE__ */ w(d, {
		present: r || o.open,
		children: o.disableHoverableContent ? /* @__PURE__ */ w(B, {
			side: i,
			...a,
			ref: t
		}) : /* @__PURE__ */ w(le, {
			side: i,
			...a,
			ref: t
		})
	});
}, "TooltipContent")), le = /* @__PURE__ */ x.forwardRef(/* @__PURE__ */ D(function(e, t) {
	let n = I(z, e.__scopeTooltip), r = P(z, e.__scopeTooltip), i = x.useRef(null), o = a(t, i), [s, c] = x.useState(null), { trigger: l, onClose: u } = n, d = i.current, { onPointerInTransitChange: f } = r, p = x.useCallback(() => {
		c(null), f(!1);
	}, [f]), m = x.useCallback((e, t) => {
		let n = e.currentTarget, r = {
			x: e.clientX,
			y: e.clientY
		}, i = H(r, V(r, n.getBoundingClientRect())), a = U(t.getBoundingClientRect()), o = G([...i, ...a]);
		c(o), f(!0);
	}, [f]);
	return x.useEffect(() => () => p(), [p]), x.useEffect(() => {
		if (l && d) {
			let e = /* @__PURE__ */ D((e) => m(e, d), "handleTriggerLeave"), t = /* @__PURE__ */ D((e) => m(e, l), "handleContentLeave");
			return l.addEventListener("pointerleave", e), d.addEventListener("pointerleave", t), () => {
				l.removeEventListener("pointerleave", e), d.removeEventListener("pointerleave", t);
			};
		}
	}, [
		l,
		d,
		m,
		p
	]), x.useEffect(() => {
		if (s) {
			let e = /* @__PURE__ */ D((e) => {
				let t = e.target, n = {
					x: e.clientX,
					y: e.clientY
				}, r = l?.contains(t) || d?.contains(t), i = !W(n, s);
				r ? p() : i && (p(), u());
			}, "handleTrackPointerGrace");
			return document.addEventListener("pointermove", e), () => document.removeEventListener("pointermove", e);
		}
	}, [
		l,
		d,
		s,
		u,
		p
	]), /* @__PURE__ */ w(B, {
		...e,
		ref: o
	});
}, "TooltipContentHoverable")), ue = o("TooltipContent"), B = /* @__PURE__ */ x.forwardRef(/* @__PURE__ */ D(function(e, t) {
	let { __scopeTooltip: r, children: i, "aria-label": a, id: o, onEscapeKeyDown: s, onPointerDownOutside: c, ...u } = e, d = I(z, r), f = A(r), { onClose: m } = d;
	x.useEffect(() => (document.addEventListener(N, m), () => document.removeEventListener(N, m)), [m]), x.useEffect(() => {
		if (d.trigger) {
			let e = /* @__PURE__ */ D((e) => {
				e.target instanceof Node && e.target.contains(d.trigger) && m();
			}, "handleScroll");
			return window.addEventListener("scroll", e, { capture: !0 }), () => window.removeEventListener("scroll", e, { capture: !0 });
		}
	}, [d.trigger, m]);
	let { setContentId: h } = d;
	return n(() => (h(o), () => {
		h(void 0);
	}), [o, h]), /* @__PURE__ */ w(l, {
		asChild: !0,
		disableOutsidePointerEvents: !1,
		onEscapeKeyDown: s,
		onPointerDownOutside: c,
		onFocusOutside: (e) => e.preventDefault(),
		onDismiss: m,
		children: /* @__PURE__ */ T(p, {
			"data-state": d.stateAttribute,
			role: a ? void 0 : "tooltip",
			id: a ? void 0 : d.contentId,
			...f,
			...u,
			ref: t,
			style: {
				...u.style,
				"--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
				"--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
				"--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
				"--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
				"--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
			},
			children: [/* @__PURE__ */ w(ue, { children: i }), a ? /* @__PURE__ */ w(b, {
				id: d.contentId,
				role: "tooltip",
				children: a
			}) : null]
		})
	});
}, "TooltipContentImpl"));
function V(e, t) {
	let n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
	switch (Math.min(n, r, i, a)) {
		case a: return "left";
		case i: return "right";
		case n: return "top";
		case r: return "bottom";
		default: throw Error("unreachable");
	}
}
D(V, "getExitSideFromRect");
function H(e, t, n = 5) {
	let r = [];
	switch (t) {
		case "top":
			r.push({
				x: e.x - n,
				y: e.y + n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "bottom":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y - n
			});
			break;
		case "left":
			r.push({
				x: e.x + n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "right":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x - n,
				y: e.y + n
			});
			break;
	}
	return r;
}
D(H, "getPaddedExitPoints");
function U(e) {
	let { top: t, right: n, bottom: r, left: i } = e;
	return [
		{
			x: i,
			y: t
		},
		{
			x: n,
			y: t
		},
		{
			x: n,
			y: r
		},
		{
			x: i,
			y: r
		}
	];
}
D(U, "getPointsFromRect");
function W(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
D(W, "isPointInPolygon");
function G(e) {
	let t = e.slice();
	return t.sort((e, t) => e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y)), K(t);
}
D(G, "getHull");
function K(e) {
	if (e.length <= 1) return e.slice();
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (; t.length >= 2;) {
			let e = t[t.length - 1], n = t[t.length - 2];
			if ((e.x - n.x) * (r.y - n.y) >= (e.y - n.y) * (r.x - n.x)) t.pop();
			else break;
		}
		t.push(r);
	}
	t.pop();
	let n = [];
	for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		for (; n.length >= 2;) {
			let e = n[n.length - 1], t = n[n.length - 2];
			if ((e.x - t.x) * (r.y - t.y) >= (e.y - t.y) * (r.x - t.x)) n.pop();
			else break;
		}
		n.push(r);
	}
	return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
D(K, "getHullPresorted");
var de = te, fe = re, q = ie, pe = se, J = ce, Y = "(hover: none)";
function me() {
	return typeof window.matchMedia == "function" && window.matchMedia(Y).matches;
}
function he() {
	let [e, t] = C(me);
	return S(() => {
		if (typeof window.matchMedia != "function") return;
		let e = window.matchMedia(Y);
		t(e.matches);
		let n = (e) => t(e.matches);
		return e.addEventListener("change", n), () => e.removeEventListener("change", n);
	}, []), e;
}
//#endregion
//#region src/foundations/tooltip/tooltip.tsx
var X = x.createContext("tooltip"), ge = de;
function _e({ touch: e = "popover", children: t, ...n }) {
	if (he() && e === "popover") {
		let { open: e, defaultOpen: r, onOpenChange: i } = n;
		return /* @__PURE__ */ w(X.Provider, {
			value: "popover",
			children: /* @__PURE__ */ w(_, {
				open: e,
				defaultOpen: r,
				onOpenChange: i,
				children: t
			})
		});
	}
	return /* @__PURE__ */ w(X.Provider, {
		value: "tooltip",
		children: /* @__PURE__ */ w(fe, {
			...n,
			children: t
		})
	});
}
var Z = x.forwardRef((e, t) => x.useContext(X) === "popover" ? /* @__PURE__ */ w(g, {
	ref: t,
	...e
}) : /* @__PURE__ */ w(q, {
	ref: t,
	...e
}));
Z.displayName = q.displayName;
var Q = "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", $ = x.forwardRef(({ className: t, sideOffset: n = 4, ...r }, i) => x.useContext(X) === "popover" ? /* @__PURE__ */ w(y, { children: /* @__PURE__ */ w(v, {
	ref: i,
	sideOffset: n,
	collisionPadding: 16,
	onOpenAutoFocus: (e) => e.preventDefault(),
	className: e(Q, "max-w-[min(20rem,calc(100vw-2rem))] outline-none", t),
	...r
}) }) : /* @__PURE__ */ w(pe, { children: /* @__PURE__ */ w(J, {
	ref: i,
	sideOffset: n,
	className: e(Q, t),
	...r
}) }));
$.displayName = J.displayName;
//#endregion
export { Z as i, $ as n, ge as r, _e as t };

//# sourceMappingURL=tooltip-BBk91-lt.js.map